import { useQuery } from '@tanstack/react-query'
import { getYouTubeQuota } from '@/services/youtube.service'
import type { YouTubeQuota } from '@/types/youtube.types'

export const youtubeQuotaKeys = {
  all: ['youtubeQuota'] as const,
}

/**
 * Fetches the authenticated user's YouTube-relevant quota balance
 * (auto-translation used/limit/can_translate).
 *
 * Intentionally NOT prefetched on player mount — only used inside the
 * no-captions panel where the user has already confirmed captions are unavailable.
 * staleTime is 60s to avoid re-fetching every render while the panel is visible.
 */
export function useYouTubeQuota() {
  return useQuery<YouTubeQuota, Error>({
    queryKey: youtubeQuotaKeys.all,
    queryFn: getYouTubeQuota,
    staleTime: 1000 * 60, // 60 seconds
    retry: 1,
  })
}
